"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Provider = function Provider(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.71,2.57A1.72,1.72,0,0,1,3.4.86,1.72,1.72,0,0,0,1.71,2.57v7h0Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.71,21.43v-7.1h0v7.1a1.73,1.73,0,0,0,1,1.58A1.73,1.73,0,0,1,1.71,21.43Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.32.86A1.72,1.72,0,0,1,24,2.57V21.43a1.69,1.69,0,0,1-.8,1.41,1.69,1.69,0,0,0,.8-1.41V2.57A1.72,1.72,0,0,0,22.32.86Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.43,23.14A1.86,1.86,0,0,1,2.76,23a1.86,1.86,0,0,0,.67.13H22.29a1.62,1.62,0,0,0,.91-.3,1.62,1.62,0,0,1-.91.3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.29.86h0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,21.43V2.57A1.72,1.72,0,0,0,22.32.86H3.4A1.72,1.72,0,0,0,1.71,2.57v7H3.43v-7H22.29V21.43H3.43v-7.1H1.71v7.1a1.73,1.73,0,0,0,1,1.58,1.86,1.86,0,0,0,.67.13H22.29a1.62,1.62,0,0,0,.91-.3A1.69,1.69,0,0,0,24,21.43Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.68,12.62,8.59,16.7a.65.65,0,0,0-.24.51.62.62,0,0,0,.14.41.65.65,0,0,0,.92.11L16,12.48a.65.65,0,0,0,.23-.52.63.63,0,0,0-.23-.51L9.41,6.2a.65.65,0,0,0-.92.1.64.64,0,0,0-.14.41.66.66,0,0,0,.24.52l5.09,4.08H.65a.66.66,0,0,0,0,1.31Z"
  }));
};

var _default = Provider;
exports["default"] = _default;